import React, { useEffect, useState } from "react";
import { getStudentProgress } from "../pages/services/statsService";

const PAGE_SIZE = 10;

const pct = (completed, total) => (total > 0 ? `${Math.round((completed / total) * 100)}%` : "no content yet");

const StudentProgressTable = () => {
  const [rows, setRows] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageSize: PAGE_SIZE, totalCount: 0 });
  const [page, setPage] = useState(1);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handle = setTimeout(() => setSearch(searchInput.trim()), 350);
    return () => clearTimeout(handle);
  }, [searchInput]);

  useEffect(() => {
    setPage(1);
  }, [search]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    getStudentProgress(page, PAGE_SIZE, search)
      .then(({ data, pagination: p }) => {
        if (cancelled) return;
        setRows(data);
        setPagination(p);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [page, search]);

  const totalPages = Math.max(1, Math.ceil((pagination.totalCount || 0) / PAGE_SIZE));

  return (
    <section className="dash-section">
      <h2 className="dash-section-title">Student progress</h2>

      <div className="lp-toolbar" style={{ marginBottom: 12 }}>
        <div className="lp-search-wrap">
          <span className="lp-search-icon">🔍</span>
          <input
            className="lp-search"
            placeholder="Search student name…"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
        </div>
      </div>

      {error ? (
        <div className="dash-section-error">Couldn't load student progress: {error}</div>
      ) : (
        <div className="lp-table-card">
          <table className="lp-table">
            <thead>
              <tr>
                <th>Student</th>
                <th>Batch</th>
                <th>Notes completed</th>
                <th>Questions completed</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={4} className="lp-state">Loading…</td>
                </tr>
              ) : rows.length === 0 ? (
                <tr>
                  <td colSpan={4} className="lp-state">No students found.</td>
                </tr>
              ) : (
                rows.map((r) => (
                  <tr key={r.studentId}>
                    <td>{r.studentName}</td>
                    <td>{r.batchName}</td>
                    <td>
                      {r.notesCompleted} / {r.notesTotal}
                      <span className="dash-progress-pct"> ({pct(r.notesCompleted, r.notesTotal)})</span>
                    </td>
                    <td>
                      {r.questionsCompleted} / {r.questionsTotal}
                      <span className="dash-progress-pct"> ({pct(r.questionsCompleted, r.questionsTotal)})</span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {!error && pagination.totalCount > 0 && (
        <div className="lp-pagination">
          <button
            className="lp-page-btn"
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page <= 1}
          >
            ← Previous
          </button>
          <span className="lp-page-info">
            Page {page} of {totalPages} · {pagination.totalCount} students
          </span>
          <button
            className="lp-page-btn"
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={page >= totalPages}
          >
            Next →
          </button>
        </div>
      )}
    </section>
  );
};

export default StudentProgressTable;
